import { ActionHandler } from 'action-handler';

// @FIXME Need to rename the field names to be less ambiguous
export default new ActionHandler({
  name: 'set_currently_syncing',
  defaultState: {
    lastSyncTime: 0,
    currentlySyncing: false,
    syncMode: 'ble'
  },
  handler({ syncing = true, wifi } = {}) {
    const action = {
      currentlySyncing: syncing,
      lastSyncTime: Date.now()
    };
    if (wifi) {
      action.syncMode = 'wifi';
    } else if (wifi === false) {
      action.syncMode = 'ble';
    }
    return action;
  },
  reduce(state, actionData) {
    return actionData;
  }
});
